'use strict';

const _ = require('lodash');
const moment = require('moment');

// TODO 這兩個也要抽出來!!!
// TODO 這兩個也要抽出來!!!
// TODO 這兩個也要抽出來!!!
const { LOCALES } = require('../../../../constants');
const optUtils = require('../../../../routes/utils/option-util');

/**
 * 回傳非 NaN 且大於 0 的合法 ID，否則回傳 undefined
 * @param src
 * @returns {number|undefined}
 */
const ID = src => {
	if (src === undefined) return undefined;
	const val = +src; // Number(src)
	return (_.isNaN(val) || !_.isNumber(val)) ? undefined : val;
};
exports.ID = ID;

/**
 * 回傳過濾掉非合法 ID 後的陣列。若 src 為空陣列或結果無合法 ID，則回傳 undefined
 * @param src
 * @param {{}} [options]
 * @param {boolean} [options.isStrict] 若為 true，則每個元素都必須為合法 ID
 * @param {boolean} [options.allowEmpty] 若為 true，則 src 為空陣列時合法。
 * @returns {number[]|undefined}
 * @see utils.validate.ID
 */
const IDS = (src, options) => {
	const _ID = ID;
	if (!_.isArray(src)) {
		const value = _ID(src);
		if (value === undefined) return undefined;
		return [value];
	}
	if (options?.allowEmpty && _.isEmpty(src)) return [];
	let values = [];
	src.map(s => {
		let id = _ID(s);
		if (id !== undefined) values.push(id);
	});
	return values.length === 0 || (options?.isStrict && src.length !== values.length) ? undefined : values;
};
exports.IDS = IDS;

/**
 * 大於等於 0 的安全整數
 * @param {number|string} src javascript 合法的數值表示. Ex: 1, 0x2, 0.3e1, 或以上的字串形式
 * @return {number|undefined}
 */
const ID_AND_ZERO = (src) => {
	if (src === undefined) return undefined;
	const val = +src;
	// _.isSafeInteger(Infinity); => false
	if (val < 0 || !_.isSafeInteger(val)) return undefined;
	return val;
};
exports.ID_AND_ZERO = ID_AND_ZERO;

const I18N = src => {
	if (!_.isPlainObject(src)) return undefined;
	const localeCodes = _.keys(LOCALES);
	src = _.pick(src, localeCodes);
	return (_.isEmpty(src) || !src[localeCodes[0]]) ? undefined : src;
};
exports.I18N = I18N;

/**
 * @param {*} src
 * @param {*} [defaultValue]
 * @returns {number|undefined}
 */
const NUMBER = (src, defaultValue) => {
	const _this = NUMBER;
	if (_.isNil(src)) return _.isNil(defaultValue) ? undefined : _this(defaultValue);
	src *= 1;
	return (_.isNaN(src) || !_.isNumber(src)) ? _this(defaultValue) : src;
};
exports.NUMBER = NUMBER;

/**
 * @param {number|number[]} srcs
 * @param {number?} defaultValue
 * @returns {number[]|undefined}
 */
const NUMBERS = (srcs, defaultValue) => {
	if (!_.isArray(srcs)) srcs = [srcs];
	const result = [];
	srcs.forEach(src => {
		src = NUMBER(src, defaultValue);
		if (!_.isNil(src)) result.push(src);
	});
	return result.length === 0 ? undefined : result;
};
exports.NUMBERS = NUMBERS;

/**
 *
 * @param src
 * @param {array} dataset
 * @param [defaultValue]
 * @returns {number|undefined}
 */
const NUMBER_IN_SET = (src, dataset, defaultValue) => {
	src = NUMBER(src, defaultValue);
	if (src === undefined) return undefined;

	dataset = dataset.map(d => d * 1);
	return _.includes(dataset, src) ? src : NUMBER_IN_SET(defaultValue, dataset);
};
exports.NUMBER_IN_SET = NUMBER_IN_SET;

/**
 *
 * @param {*[]} src
 * @param {array} dataset
 * @param {*[]} [defaultValue]
 * @returns {number[]|undefined}
 */
const NUMBERS_IN_SET = (src, dataset, defaultValue) => {
	if (src instanceof Array) {
		const values = src.reduce((previousValue, currentValue) => {
			const num = NUMBER_IN_SET(currentValue, dataset, defaultValue);
			if (num !== undefined) previousValue.push(num);
			return previousValue;
		}, []);
		return values.length ? values : undefined;
	}

	const value = NUMBER_IN_SET(src, dataset, defaultValue);
	return value === undefined ? undefined : [value];
};
exports.NUMBERS_IN_SET = NUMBERS_IN_SET;

/**
 * @param {*} src
 * @param {*} [lower] (include)
 * @param {*} [upper] (include)
 * @returns {number|undefined}
 */
const NUMBER_IN_RANGE = (src, lower, upper) => {
	src = NUMBER(src);
	if (src === undefined) return undefined;
	lower = NUMBER(lower);
	upper = NUMBER(upper);
	if (upper !== undefined && src < lower) return undefined;
	if (lower !== undefined && src > upper) return undefined;
	return src;
};
exports.NUMBER_IN_RANGE = NUMBER_IN_RANGE;

/**
 * 檢查 src 是否為 OPTIONS[key] 裡存在的鍵值。否的話回傳 undefined
 * @param {*} src
 * @param {string} key OPTIONS 裡面的 key (例如 ac.loginMethod 或 wf.ws.usedStatus)
 * @param {*} [defaultValue]
 * @returns {number|undefined}
 */
const NUMBER_IN_OPT_KEY = (src, key, defaultValue) => {
	return NUMBER_IN_SET(src, optUtils.getKeys(key), defaultValue);
};
exports.NUMBER_IN_OPT_KEY = NUMBER_IN_OPT_KEY;

/**
 * 從 src 裡挑出 OPTIONS[key] 裡存在的鍵值。都沒有的話回傳 undefined
 * @param {*[]} src
 * @param {string} key OPTIONS 裡面的 key (例如 ac.loginMethod 或 wf.ws.usedStatus)
 * @param {*[]} [defaultValue]
 * @returns {number[]|undefined}
 */
const NUMBERS_IN_OPT_KEY = (src, key, defaultValue) => {
	return NUMBERS_IN_SET(src, optUtils.getKeys(key), defaultValue);
};
exports.NUMBERS_IN_OPT_KEY = NUMBERS_IN_OPT_KEY;

/**
 * @param {*} src
 * @param {*} [defaultValue]
 * @param {boolean} [trim] src 是否先做 trim
 * @returns {string|undefined}
 */
const STRING = (src, defaultValue, trim = true) => {
	const _this = STRING;
	if (_.isNil(src) || _.isNaN(src)) return _.isNil(defaultValue) ? undefined : _this(defaultValue, trim);
	if (trim) return (src + '').trim();
	return (src + '');
};
exports.STRING = STRING;

/**
 * 確保 src 的每個元素都是字串或 defaultValue
 * @param {array} src
 * @param defaultValue 直接加在結果裡，不會被轉成字串
 * @param {boolean} trim 每個字串元素是否做 trim()
 * @returns {undefined|array<string>}
 */
const STRINGS = (src, defaultValue = undefined, trim = true) => {
	if (!src) return undefined;
	if (src && !_.isArray(src) && src.length > 0) {
		const finalSrc = [];
		finalSrc.push(src);
		src = finalSrc;
	}
	return src.map(val => {
		val = (_.isNil(val) || _.isNaN(val)) ? defaultValue : String(val);
		if (val && trim && _.isFunction(val.trim)) val = val.trim();
		return val;
	});
};
exports.STRINGS = STRINGS;

/**
 * @param src
 * @param {array|object} dataset
 * @param [defaultValue] <b>注意！如果 src isNil, 則結果是 undefined, 而不是 defaultValue！</b>
 * @param [trim]
 * @returns {string|undefined}
 */
const STRING_IN_SET = (src, dataset, defaultValue, trim = true) => {
	src = STRING(src, defaultValue, trim);
	if (src === undefined) return undefined;
	return dataset.some(d => d == src) ? src : STRING_IN_SET(defaultValue, dataset);
};
exports.STRING_IN_SET = STRING_IN_SET;

/**
 * @param src
 * @param {array|object} dataset
 * @param [defaultValue]
 * @param [trim]
 * @returns {string[]|undefined}
 */
const STRINGS_IN_SET = (src, dataset, defaultValue, trim = true) => {
	if (src instanceof Array) {
		const values = src.reduce((previousValue, currentValue) => {
			const str = STRING_IN_SET(currentValue, dataset, defaultValue, trim);
			if (str !== undefined) previousValue.push(str);
			return previousValue;
		}, []);
		return values.length ? values : undefined;
	}

	const value = STRING_IN_SET(src, dataset, defaultValue, trim);
	return value === undefined ? undefined : [value];
};
exports.STRINGS_IN_SET = STRINGS_IN_SET;

/**
 * 檢查 src 是否為 OPTIONS[key] 裡存在的鍵值。否的話回傳 undefined<br/>
 * (跟 STRING_IN_SET 的差別是只要傳 optionKey ，不用自己撈 option)
 * @param {*} src
 * @param {string} key OPTIONS 裡面的 key (例如 ac.ruleType 或 am.leaveitem.unit)
 * @param {*} [defaultValue]
 * @param {boolean} [trim]  src 是否要先做 trim
 * @returns {string|undefined}
 */
const STRING_IN_OPT_KEY = (src, key, defaultValue, trim) => {
	return STRING_IN_SET(src, optUtils.getKeys(key), defaultValue, trim);
};
exports.STRING_IN_OPT_KEY = STRING_IN_OPT_KEY;

/**
 * 從 src 裡挑出 OPTIONS[key] 裡存在的鍵值。都沒有的話回傳 undefined<br/>
 * (跟 STRINGS_IN_SET 的差別是只要傳 optionKey ，不用自己撈 option)
 * @param {*[]} src
 * @param {string} key OPTIONS 裡面的 key (例如 ac.ruleType 或 am.leaveitem.unit)
 * @param {*[]} [defaultValue]
 * @param {boolean} [trim]  src 裡面的每個值是否要先做 trim
 * @returns {string[]|undefined}
 */
const STRINGS_IN_OPT_KEY = (src, key, defaultValue, trim) => {
	return STRINGS_IN_SET(src, optUtils.getKeys(key), defaultValue, trim);
};
exports.STRINGS_IN_OPT_KEY = STRINGS_IN_OPT_KEY;

const STRING_IN_KEYVALUE = (src, dataset, trim = true) => {
	//確認src是否存在dataset的key or value裡
	//dataset sample => {key1: value1, key2: value2, ...}
	src = STRING(src, null, trim);
	if (src === undefined) return undefined;
	if (!(typeof (dataset) === 'object')) return undefined;
	if (_.has(dataset, src)) //檢查值是否在key的位置
		return src;
	const idx = _.indexOf(_.values(dataset), src);
	if (idx > -1)	//檢查值是否在value的位置
		return Object.keys(dataset)[idx];

	return undefined;
};
exports.STRING_IN_KEYVALUE = STRING_IN_KEYVALUE;

const STRING_IN_VALUE = (src, dataset, trim = true) => {
	//確認src是否存在dataset的key or value裡
	//dataset sample => {key1: value1, key2: value2, ...}
	src = STRING(src, null, trim);
	if (src === undefined) return undefined;
	if (!(typeof (dataset) === 'object')) return undefined;
	const idx = _.indexOf(_.values(dataset), src);
	if (idx > -1)	//檢查值是否在value的位置
		return Object.keys(dataset)[idx];

	return undefined;
};
exports.STRING_IN_VALUE = STRING_IN_VALUE;
/**
 *
 * @param src
 * @param {array|object} dataset
 * @param defaultValue
 * @param trim
 * @returns {undefined|*}
 */
const STRING_IN_SET_CODENAME = (src, dataset, defaultValue, trim = true) => {
	src = STRING(src, null, trim);
	if (src === undefined) return undefined;
	let data = _.find(dataset, (o) => { return o.code == src || o.name == src; });
	return data ? { src, code: data.id ? data.id : data.code } : STRING_IN_SET_CODENAME(defaultValue, dataset);
};
exports.STRING_IN_SET_CODENAME = STRING_IN_SET_CODENAME;

/**
 *
 * @param src
 * @param {number} min
 * @param {number} max
 * @param {boolean} [cut]
 * @returns {string|undefined}
 */
const STRING_IN_LENGTH = (src, min, max, cut = true) => {
	src = STRING(src);
	if (src === undefined) return undefined;
	min = NUMBER(min);
	max = NUMBER(max);
	let length = src.length;
	if (min !== undefined && length < min) return undefined;
	if (max !== undefined && length > max) {
		if (cut) {
			return src.substring(0, max);
		}
		else {
			return undefined;
		}
	}
	return src;
};
exports.STRING_IN_LENGTH = STRING_IN_LENGTH;

/**
 * 長度超出指定範圍的字串回傳 undefined
 * @param src
 * @param {number} min
 * @param {number} max
 * @returns {undefined|string}
 */
const STRING_IN_LIMIT = (src, min, max) => {
	return STRING_IN_LENGTH(src, min, max, false);
};
exports.STRING_IN_LIMIT = STRING_IN_LIMIT;

const TIME_HHMM = (src, baseDate = 'today', defaultValue) => {
	let m = moment(`${baseDate === 'today' ? '1900/01/02' : baseDate === 'yesterday' ? '1900/01/01' : '1900/01/03'} ${src}`, 'YYYY/MM/DD HH:mm');
	if (m.isValid() && src !== undefined) return m.toDate();
	return src || !defaultValue ? undefined : TIME_HHMM(defaultValue);
};
exports.TIME_HHMM = TIME_HHMM;

/**
 *
 * @param str
 * @param {'today'|'yesterday'|'nextday'|'none'} baseDate
 * @param defaultValue
 * @return {undefined|string}
 */
const TIME_HHMM_STR = (str, baseDate = 'today', defaultValue) => {
	if (str?.length === 5 && baseDate !== 'none')
		str = `${baseDate === 'today' ? '1900/01/02' : baseDate === 'yesterday' ? '1900/01/01' : '1900/01/03'} ${str}`;
	let m = moment(str, baseDate === 'none' ? 'HH:mm' : 'YYYY/MM/DD HH:mm');
	if (m.isValid()) return m.format(baseDate === 'none' ? 'HH:mm' : 'YYYY/MM/DD HH:mm');
	return str || !defaultValue ? undefined : TIME_HHMM_STR(defaultValue);
};
exports.TIME_HHMM_STR = TIME_HHMM_STR;

/**
 * @param {*} src 任何 moment 能 parse 的東西
 * @param {*} [defaultValue] 任何 moment 能 parse 的東西
 * @returns {Date|undefined} Javascript Date 或 undefined
 */
const DATE = (src, defaultValue) => {
	let m = moment(src); // Date.parse('2012/02/31') 會得到 2012/03/02, 故 moment 不可替代
	if (m.isValid() && src !== undefined) return m.toDate(); // 輸出轉 Date
	return src || !defaultValue ? undefined : DATE(defaultValue); // defaultValue 勿傳 0000-00-00
};
exports.DATE = DATE;

const DATETIME = (src, defaultValue) => {
	let m = moment(src); // Date.parse('2012/02/31') 會得到 2012/03/02, 故 moment 不可替代
	if (m.isValid() && src !== undefined) return m.toDate(); // 輸出轉 Date
	return src || !defaultValue ? undefined : DATETIME(defaultValue); // defaultValue 勿傳 0000-00-00
};
exports.DATETIME = DATETIME;

/**
 * 驗證日期字串。使用此方法時，前端 valueType 請使用 string
 * @param {*} str moment 能 parse 的日期字串
 * @param {*} [defaultValue] moment 能 parse 的日期字串
 * @param {string} strFormat str 的格式 (預設是前端常見的 YYYY/MM/DD)
 * @param {string} outFormat return 的格式 (預設是 DB 格式的 YYYY-MM-DD)
 * @return {string|undefined} 符合 outFormat 格式的字串
 */
const DATE_STR = (str, defaultValue, strFormat = 'YYYY/MM/DD', outFormat = 'YYYY-MM-DD') => {
	let m = moment(str, strFormat);
	if (m.isValid() && str !== undefined) return m.format(outFormat);
	return str || !defaultValue ? undefined : DATE_STR(defaultValue, undefined, strFormat, outFormat);
};
exports.DATE_STR = DATE_STR;

/**
 * 驗證日期時間字串。使用此方法時，前端 valueType 請使用 string
 * @param str moment 能 parse 的日期時間字串
 * @param [isSecond] 是否包含秒數(預設 false)
 * @param [strFormat] 預設 'YYYY/MM/DD HH:mm'
 * @param [outFormat] 預設 'YYYY-MM-DD HH:mm'
 * @return {undefined|string}
 * @constructor
 */
const DATETIME_STR = (str, isSecond = false, strFormat = 'YYYY/MM/DD HH:mm', outFormat = 'YYYY-MM-DD HH:mm') => {
	const m = moment(str, `${strFormat}${isSecond ? ':ss' : ''}`);
	if (m.isValid() && str !== undefined) return m.format(`${outFormat}${isSecond ? ':ss' : ''}`);
	return undefined;
};
exports.DATETIME_STR = DATETIME_STR;

const DATETIME_RANGE_STR = (src, isSecond = false, strFormat = 'YYYY/MM/DD HH:mm', outFormat = 'YYYY-MM-DD HH:mm') => {
	if (!Array.isArray(src) || src.length < 2) return undefined;
	if (src.length > 2) src = src.slice(0, 2);
	src = src.map(s => DATETIME_STR(s, isSecond, strFormat, outFormat));
	return src[0] === undefined || src[1] === undefined ? undefined : src;
};
exports.DATETIME_RANGE_STR = DATETIME_RANGE_STR;

const DATE_FOR_RANGE = (src, defaultValue) => {
	if (!_.isArray(src)) return DATE(src); //如果不是傳入array，則將值扔到DATE去處理
	return src.map(value => DATE(value, defaultValue));
};
exports.DATE_FOR_RANGE = DATE_FOR_RANGE;

const DATE_RANGE = src => {
	if (!_.isArray(src) || src.length < 2) return undefined;
	if (src.length > 2) src = src.slice(0, 2);
	src = _.map(src, s => DATE(s));
	return src[0] === undefined || src[1] === undefined ? undefined : src;
};
exports.DATE_RANGE = DATE_RANGE;

const DATE_RANGES = src => {
	if (!_.isArray(src)) return undefined;
	src = _.compact(_.map(src, DATE_RANGE));
	const result = [];
	_.forEach(src, s => {
		if (result.length === 0) return result.push(s);
		if (_.every(result, r => (r[0] > s[0] && r[0] > s[1]) || (r[1] < s[0] && r[1] < s[1])))
			return result.push(s);
	});
	return result.length === 0 ? undefined : result;
};
exports.DATE_RANGES = DATE_RANGES;

const DATE_RANGE_STR = (src, strFormat = 'YYYY/MM/DD', outFormat = 'YYYY-MM-DD') => {
	if (!_.isArray(src) || src.length < 2) return undefined;
	if (src.length > 2) src = src.slice(0, 2);
	src = _.map(src, str => DATE_STR(str, undefined, strFormat, outFormat));
	return src[0] === undefined || src[1] === undefined ? undefined : src;
};
exports.DATE_RANGE_STR = DATE_RANGE_STR;

const YEAR_MONTH_STR_OPTS = { isAD: true, srcFmt: 'YYYY/MM', outFmt: 'YYYY/MM' };
/**
 * @param {string} src - 'YYYY/MM'
 * @param {{isAD?:boolean, srcFmt?:string, outFmt?:string }} [options]
 * @return {undefined|string}
 * @constructor
 */
const YEAR_MONTH_STR = (src, options = {}) => {
	const opt = _.defaults({}, options, YEAR_MONTH_STR_OPTS);
	let m = moment(src, opt.srcFmt);
	if (!m.isValid() || src === undefined) return undefined;
	return m.format(opt.outFmt);
};
exports.YEAR_MONTH_STR = YEAR_MONTH_STR;

/**
 * @type {{infinity: 'none'|'left'|'right'|'both'}}
 */
const YEAR_MONTH_STR_RANGE_OPTS = { infinity: 'none' };
/**
 *
 * @param {[string, string]} src - ['YYYY/MM', 'YYYY/MM']
 * @param {{infinity?: 'none'|'left'|'right'|'both'}} [options]
 * @return {undefined|[(undefined|string), (undefined|string)]}
 */
const YEAR_MONTH_STR_RANGE = (src, options = {}) => {
	if (!_.isArray(src) || src.length !== 2) return undefined;
	const opt = _.defaults({}, options, YEAR_MONTH_STR_RANGE_OPTS);
	src = _.map(src, str => YEAR_MONTH_STR(str, opt));
	return (src[0] === undefined && (opt.infinity !== 'both' && opt.infinity !== 'left'))
	|| (src[1] === undefined && (opt.infinity !== 'both' && opt.infinity !== 'right')) ? undefined : src;
};
exports.YEAR_MONTH_STR_RANGE = YEAR_MONTH_STR_RANGE;

const TIMESTAMP = (src) => {
	const num = Number(src);
	if (isNaN(num) || (src === null || (typeof src === 'string' && src.trim().length === 0)) || num < 0) return undefined;
	return num;
};
exports.TIMESTAMP = TIMESTAMP;

const TIMESTAMP_RANGE = src => {
	if (!_.isArray(src) || src.length !== 2) return undefined;
	src = _.map(src, s => _.isNumber(s) && moment(s).isValid() && s);
	return src[0] === false || src[1] === false ? undefined : src;
};
exports.TIMESTAMP_RANGE = TIMESTAMP_RANGE;

/**
 * 回傳 true 或 false 代表的布林值
 * @param {*} src
 * @param {*} [defaultValue]
 * @returns {boolean|undefined|*}
 */
const BOOLEAN = (src, defaultValue) => {
	const _this = BOOLEAN;
	if (_.isNil(src)) return _.isNil(defaultValue) ? undefined : _this(defaultValue);
	if (_.isString(src) && src.toUpperCase() === 'TRUE') return true;
	if (_.isString(src) && src.toUpperCase() === 'FALSE') return false;
	if (_.isFinite(src)) return src !== 0;
	return _.isBoolean(src) ? src : _this(defaultValue);
};
exports.BOOLEAN = BOOLEAN;

/**
 * 回傳 1 或 0 代表的布林值
 * @param {*} src
 * @param {*} [defaultValue]
 * @returns {0|1|undefined}
 */
const BOOLEAN_IN_ZO = (src, defaultValue) => {
	const b = BOOLEAN(src, defaultValue);
	if (b === undefined) return undefined;
	else return b ? 1 : 0;
};
exports.BOOLEAN_IN_ZO = BOOLEAN_IN_ZO;

const MAIL = src => {
	src = STRING_IN_LIMIT(src, 0, 60);
	if (!src) return undefined;
	//套用ehrms2的mail檢查
	const _F = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/i;
	//const _F = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return _F.test(src) ? src : undefined;
};
exports.MAIL = MAIL;

/**
 * @deprecated 請用其它的 method 代替，並檢查結果是否為 undefined
 */
const REQUIRE = (src) => {
	if (src === 0) return 0;
	if (!src) return undefined; // false,null,undefined,NaN,''
	if (src instanceof Date) return src;
	// [], {} 屬於'空'資料(client有傳 只是資料為empty), 不是'無'資料(client沒傳 不合法)
	//if (typeof (src) === 'object' && _.isEmpty(src)) return undefined; // [],{}
	return src;
};
/**
 * @deprecated 請用其它的 method 代替，並檢查結果是否為 undefined
 */
exports.REQUIRE = REQUIRE;

const DECIMAL = (src, precision, scale, sign) => {
	if (src === undefined) return undefined;
	const strNum = +src + ''; // Number(src).toString()
	const strSign = sign ? '-?' : ''; // 允許負值
	const strPoint = +scale > 0 ? `(\\.\\d{1,${+scale}})?` : ''; // 計算小數位
	const strDec = +precision > +scale ? `\\d{1,${precision - scale}}|` : ''; // 計算整數位
	const regValid = new RegExp(`^${strSign}(${strDec}0)${strPoint}$`, 'i'); // 最少有 0
	return regValid.test(strNum) ? +src : undefined;
};
exports.DECIMAL = DECIMAL;

/**
 * 回傳補零至指定 scale 長度的 decimal 字串
 * @param src
 * @param precision
 * @param scale
 * @param sign
 * @returns {string|undefined}
 */
const DECIMAL_STR = (src, precision, scale, sign) => {
	if (undefined === DECIMAL(src, precision, scale, sign)) return undefined;
	src = String(src);
	const parts = src.split('.');
	const needPad = !parts[1] ? scale : (scale - parts[1].length);
	if (needPad === 0) return src;
	if (!parts[1]) src += '.';
	return src + _.padEnd('', needPad, '0');
};
exports.DECIMAL_STR = DECIMAL_STR;

const YESNO = src => {
	if (_.findIndex(['是', '否', 'Y', 'N', 'y', 'n'], (o) => { return o === src; }) === -1) {
		return undefined;
	}
	return _.includes(['是', 'Y', 'y'], src) ? '1' : '0';
};
exports.YESNO = YESNO;

/**
 * 確保部門的 org 跟 depts 都合法
 * @param {{org: number, depts: number[]}} src
 * @returns {Object<string, number[]>|undefined} key 是 org，值是 depts。只要其中一個不合法，整個就回傳 undefined
 */
const ORG = (src) => {
	const result = ORG_DEPTS(src);
	if (!result) return undefined;
	return { [`${result.org}`]: result.depts };
};
exports.ORG = ORG;

/**
 * 確保部門的 org 跟 depts 都合法
 * @param {{org: number, depts: number[]}} src
 * @return {{org: number, depts: number[]}|undefined} 回傳格式同 src
 * @see ORG
 */
const ORG_DEPTS = (src) => {
	if (!_.isPlainObject(src)) return undefined;
	if (!src.org || _.isEmpty(src.depts)) return undefined;
	const org = NUMBER_IN_RANGE(src.org, 1, 5);
	const depts = IDS(src.depts, { isStrict: true });
	if (!org || !depts) return undefined;
	return { org, depts };
};
exports.ORG_DEPTS = ORG_DEPTS;

/**
 * 確保樹狀元件的值都合法
 * @param {{parent: *, value: *}[]} src 檢驗的對象值
 * @param {boolean} req 預設只要其中一個不合法，整個就回傳 undefined，用 false 容錯
 * @param {function} vf 驗證方法，預設是 ID
 * @returns {*[]} 收集的值，分成父集和子集
 */
const TREE_LEAF = (src, req = true, vf = ID) => {
	if (!Array.isArray(src)) return undefined;
	const arrList1 = [[], [], {}];
	const fail = src.some(({ parent, value }) => {
		const p = vf(parent);
		if (p === undefined) return req;
		arrList1[0].push(p);
		if (value === undefined) return false;

		const c = vf(value);
		if (c === undefined) return req;
		arrList1[1].push(c);
		arrList1[2][p] = 1;
		return false;
	});
	if (fail || !arrList1[0].length) return undefined;
	arrList1[0] = arrList1[0].filter(q => !arrList1[2][q]);
	return arrList1;
};
exports.TREE_LEAF = TREE_LEAF;

/**
 * @deprecated 請用其它的 method 代替，例如 IDS, NUMBERS, STRINGS, ...
 */
const ARRAY = (src, min, max, defaultValue) => {
	if (!_.isArray(src)) return defaultValue;
	if (_.isNumber(min) && min > 0 && src.length < min) return defaultValue;
	if (_.isNumber(max) && max > 0 && src.length > min) src = _.slice(src, 0, max);
	return src || defaultValue;
};
/**
 * @deprecated 請用其它的 method 代替，例如 IDS, NUMBERS, STRINGS, ...
 */
exports.ARRAY = ARRAY;

/**
 * @deprecated 請詳列並檢查 object 內的每個 property
 */
const OBJECT = (src, defaultValue) => {
	return _.isObject(src) ? src : defaultValue;
};
/**
 * @deprecated 請詳列並檢查 object 內的每個 property
 */
exports.OBJECT = OBJECT;

/**
 * 檢查是否符合 nanoid 產生的結果 (目前主要是想避免 SQL-injection)
 * @param {string} src
 * @param {number} [len]
 * @return {undefined}
 * @see https://github.com/ai/nanoid#api
 */
const NANOID = (src, len) => {
	if (!_.isString(src)) return undefined;
	if (len && src.length !== len) return undefined;
	if (/[^A-Za-z0-9_-]/.test(src)) return undefined;
	return src;
};
exports.NANOID = NANOID;

// 僅簡單驗證 JWT 格式，不驗證是否實際合法、有效
const JWT_PATTERN = /^(?:[A-Za-z0-9-_]+\.){2}[A-Za-z0-9-_]+$/;
/**
 * 檢查是否符合 JWT 字串格式 xxxxx.yyyyy.zzzzz
 * @param {string} src
 * @return {undefined|string}
 */
const JWT = (src) => {
	src = STRING(src);
	return JWT_PATTERN.test(src) ? src : undefined;
};
exports.JWT = JWT;

/**
 * 濾掉可能造成原型污染的值
 * @param {*} src
 * @return {undefined|*} 若 src 是 '__proto__', 'prototype', 'constructor' 之一，則回傳 undefined，否則回傳原本的 src
 */
const NO_POLLUTION = (src) => {
	return src === '__proto__' || src === 'prototype' || src === 'constructor' ? undefined : src;
};
exports.NO_POLLUTION = NO_POLLUTION;
